import React from 'react';
import AppStatic, { isTeachersBuild, isStudentsBuild } from '../config/AppStatic';
import Button from './ui/Button';
import { HiUser, HiAcademicCap, HiXMark } from 'react-icons/hi2';

function MobileFilterButtons({
    selectedTeacher,
    selectedGroups,
    onOpenStudentModal,
    onOpenTeacherModal,
    onClearFilters,
    teachers,
    groups,
    showTeacher = true,
    showStudent = true,
    compact = false
}) {
    // Check if any filters are active
    const hasActiveFilters = selectedTeacher || (selectedGroups && selectedGroups.length > 0);

    // Get display text for active filters
    const getActiveFilterText = () => {
        if (selectedTeacher) {
            return selectedTeacher;
        }
        if (selectedGroups && selectedGroups.length > 0) {
            const groupName = selectedGroups[0];
            return groupName;
        }
        return null;
    };

    const activeFilterText = getActiveFilterText();

    // If filters are active, show the selected value with close button
    if (hasActiveFilters) {
        return (
            <div className={compact ? "flex items-center gap-1" : "flex items-center justify-center gap-2"}>
                <span className={compact ? "text-base font-semibold text-black" : "text-black text-lg font-medium"}>{activeFilterText}</span>
                <button
                    onClick={onClearFilters}
                    className={compact ? "p-1 rounded-full hover:bg-gray-100" : "p-1 hover:bg-gray-100 rounded-full transition-colors"}
                    aria-label="Clear filter"
                >
                    <HiXMark className={compact ? "h-4 w-4 text-black" : "h-5 w-5 text-black"} />
                </button>
            </div>
        );
    }

    // Compact mode: a single small button that opens the appropriate modal
    if (compact) {
        const appType = AppStatic.getBuildType();
        const handleOpen = () => {
            if (isTeachersBuild() && showTeacher) return onOpenTeacherModal && onOpenTeacherModal();
            if (isStudentsBuild() && showStudent) return onOpenStudentModal && onOpenStudentModal();
            // Fallbacks
            if (showTeacher) return onOpenTeacherModal && onOpenTeacherModal();
            if (showStudent) return onOpenStudentModal && onOpenStudentModal();
        };
        return (
            <Button
                variant="secondary"
                onClick={handleOpen}
                className="flex items-center gap-1 px-2 py-1 text-xs"
                aria-label="Open filters"
                title="Open filters"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                    <path fillRule="evenodd" d="M3.75 4.5a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5H3.75zm3 6a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H6.75zm3 6a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5z" clipRule="evenodd" />
                </svg>
                Filter
            </Button>
        );
    }

    // Default state: show student and teacher buttons stacked
    return (
        <div className="flex flex-col gap-2">
            {showStudent && (
                <Button
                    variant="secondary"
                    onClick={onOpenStudentModal}
                    className="flex items-center gap-2 px-3 py-2 text-sm w-full justify-center"
                >
                    <HiAcademicCap className="h-4 w-4" />
                    I am a student
                </Button>
            )}

            {showTeacher && (
                <Button
                    variant="secondary"
                    onClick={onOpenTeacherModal}
                    className="flex items-center gap-2 px-3 py-2 text-sm w-full justify-center"
                >
                    <HiUser className="h-4 w-4" />
                    I am a teacher
                </Button>
            )}
        </div>
    );
}

export default MobileFilterButtons;
